function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Cart");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.73,
  strokeLinecap: "square"
}, React.createElement("g", {
  id: "icon-cart",
  transform: "translate(1.000000, 1.000000)",
  stroke: "#FFFFFF"
}, React.createElement("polygon", {
  id: "Path",
  points: "2.70846395 0.695652174 19.6363636 0.695652174 17.9435737 9.73913043 4.40125392 9.73913043"
}), React.createElement("ellipse", {
  id: "Oval",
  cx: 6.43260188,
  cy: 14.2608696,
  rx: 1.69278997,
  ry: 1.73913043
}), React.createElement("ellipse", {
  id: "Oval-Copy-2",
  cx: 15.9122257,
  cy: 14.2608696,
  rx: 1.69278997,
  ry: 1.73913043
}), React.createElement("path", {
  d: "M2.70846395,0.347826087 L0,0.347826087",
  id: "Path",
  strokeWidth: 2
})));

const SvgCart = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cart.e5cd1ea8.svg";
export { ForwardRef as ReactComponent };